//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { GameStatus, Multiplier, Game, WheelColor } from './wheel.entity';

import UiGameSidebar from "./components/SideBar.vue";
import WheelHomeGame from "./components/HomeGame.vue";
import WheelHomeHistory from "./components/HomeHistory.vue";

import WheelSidebarBets from './components/SidebarBets.vue';

// 旧版下注与创建组件
import WheelHomeBetContent from './components/HomeBetContent.vue';
import WheelHomeBetCreator from './components/HomeBetCreator.vue';

// 新版下注与创建组件
import WheelHomeBetContentNew from './components/HomeBetContentNew.vue';
import WheelHomeBetCreatorNew from './components/HomeBetCreatorNew.vue';

// 倍率选择组件
import WheelGameColorTabs from './components/GameColorTabs.vue';
import WheelGameColor from './components/GameColor.vue';


export default {
  name: 'WheelHome',
  components: {
    WheelHomeGame,
    WheelHomeHistory,
    WheelSidebarBets,
    WheelHomeBetContent,
    WheelHomeBetCreator,
    WheelHomeBetContentNew,
    WheelHomeBetCreatorNew,
    WheelGameColorTabs,
    WheelGameColor,
    UiGameSidebar
  },
  data() {
    return {
      GameStatus,
      Multiplier,
      MIN_BET_AMOUNT_USD: 0.25,
      fastAmounts: [],
      turnOffAnimation: false,
      currentColor: Multiplier.X2,
      isCreatingBet: false,
      betOnColorClick: false,
      windowWidth: window.innerWidth,

      authState: {
        isAuthenticated: () => !!this.user.id,
        betType: () => 'BALANCE',
        betAmountUsd: 1.0
      },
      wheelState: {
        game: new Game(),
        userBets: [],
        colorX2: new WheelColor(),
        colorX3: new WheelColor(),
        colorX4: new WheelColor(),
        colorX35: new WheelColor(),
        history: [],          // 保存历史游戏记录
        colorStats: null,     // 保存最近100轮各倍率的出现频次，例如: { [Multiplier.X2]: 40, [Multiplier.X3]: 30, ... }
      },
      settingsState: {
        disableAnimations: false
      },
      inventoryState: {
        selectedInventoryAmountUsd: () => 0,
        selectedIds: () => []
      },
      howItWorksSlides: []
    };
  },
  computed: {
    ...mapState(["user"]),
    isSm() {
      return this.windowWidth <= 767;
    },
    isLg() {
      return this.windowWidth <= 991;
    },
    wheelHistoryRouteName() {
      if (this.currencyType === 1) return 'happyCoinCrashHistory';
      if (this.currencyType === 2) return 'coin1CrashHistory';
      return 'crashHistory';
    },
    currencyType() {
      return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
    },
    currencyTypeLabel() {
      if (this.currencyType === 1) return '欢乐豆';
      if (this.currencyType === 2) return '金豆';
      return '现金';
    },
    allBalance() {
      if (this.currencyType === 1) return this.user?.happyCoin || 0;
      if (this.currencyType === 2) return this.user?.coin1Available || 0;
      return this.user?.recycles || 0;
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    await this.initHub();

    const savedBetOnColor = localStorage.getItem('wheelConfirm_betOnColorClick');
    if (savedBetOnColor !== null) {
      this.betOnColorClick = JSON.parse(savedBetOnColor);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.resetWheelState();
  },
  methods: {
    async initHub() {
      if (this.$wheelHub.conn && this.$wheelHub.conn.stop) await this.$wheelHub.conn.stop();

      this.$wheelHub.initHub(this.currencyType);

      if (!this.$wheelHub.conn) {
        return;
      }

      this.bindHubEvents();
    },
    getHubHandlers() {
      return {
        "GameConfig": this.onGameConfig,
        "OnWsCurrentGame": this.onWsCurrentGame,
        "OnWsNewGame": this.onWsNewGame,
        "OnWsStartSpin": this.onWsStartSpin,
        "OnWsGameEnded": this.onWsGameEnded,
        "OnWsNewBet": this.onWsNewBet
      };
    },
    bindHubEvents() {
      if (!this.$wheelHub || !this.$wheelHub.conn) {
        return;
      }

      const handlers = this.getHubHandlers();
      Object.keys(handlers).forEach((eventName) => {
        this.$wheelHub.conn.off(eventName, handlers[eventName]);
        this.$wheelHub.conn.on(eventName, handlers[eventName]);
      });
    },

    unbindHubEvents() {
      if (!this.$wheelHub || !this.$wheelHub.conn) {
        return;
      }

      const handlers = this.getHubHandlers();
      Object.keys(handlers).forEach((eventName) => {
        this.$wheelHub.conn.off(eventName, handlers[eventName]);
      });
    },
		onGameConfig(data) {
      this.MIN_BET_AMOUNT_USD = data.minBetAmount;
      this.fastAmounts = [ `${data.minBetAmount}` , `${data.minBetAmount*2}` , `${data.minBetAmount * 5}`]; 
		},
    onWsCurrentGame(gameData) {
      if (!gameData) return;

      // 1. 同步当前轮盘游戏的基础信息（局号、状态、FairGame 哈希等）
      this.wheelState.game = gameData.game;

      // 2. 重置所有倍率区域
      this.wheelState.userBets = [];
      this.wheelState.colorX2 = new WheelColor();
      this.wheelState.colorX3 = new WheelColor();
      this.wheelState.colorX4 = new WheelColor();
      this.wheelState.colorX35 = new WheelColor();

      this.wheelState.colorStats = gameData.colorsStats;

      // 4. 汇总个人在当前局的下注记录
      const allBets = gameData.bets || gameData.Bets || [];

      // 遍历所有下注数据进行填充
      allBets.forEach(bet => {
        // 强制转换为布尔值，兼容后端 ID 类型（Number 与 String 的匹配）
        bet.isOwn = String(bet.userId || bet.user?.id) === String(this.user?.id);

        const targetColorKey = this.getColorKeyByMultiplier(bet.color ?? bet.colorId);
        if (targetColorKey && this.wheelState[targetColorKey]) {
          const colorBank = this.wheelState[targetColorKey];

          // 累加底池
          colorBank.totalBankUsd += Number(bet.itemsTotal || bet.betAmount || 0);

          // 统计独立玩家数
          const currentUserId = bet.userId || bet.user?.id;
          const hasUserBet = colorBank.bets.some(b => String(b.userId || b.user?.id) === String(currentUserId));
          if (!hasUserBet) {
            colorBank.usersCount += 1;
          }

          // 推入颜色区域的下注数组
          colorBank.bets.unshift(bet);
        }

        // 如果是个人下注，放入 userBets
        if (bet.isOwn) {
          this.wheelState.userBets.unshift(bet);
        }
      });


      // 5. 如果返回了历史开奖数据，同步历史记录
      const history = gameData.history || gameData.History;
      if (history && Array.isArray(history)) {
        this.wheelState.history = history;
      }

      console.warn("OnWsCurrentGame 初始化完成", gameData);
    },
    // 收到新游戏推送：使用 WheelColor 类实例彻底清空并重置
    onWsNewGame(gameData) {
      this.wheelState.game = gameData;
      this.wheelState.userBets = [];
      this.wheelState.colorX2 = new WheelColor();
      this.wheelState.colorX3 = new WheelColor();
      this.wheelState.colorX4 = new WheelColor();
      this.wheelState.colorX35 = new WheelColor();
      console.warn("onWsNewGame", gameData);
    },

    onWsStartSpin(spinData) {
      if (this.wheelState.game) {
        this.wheelState.game.status = GameStatus.STARTED;
        this.wheelState.game.winNumber = spinData.EndNumber || spinData.endNumber;
      }
      console.warn("onWsStartSpin", spinData);
    },

    onWsGameEnded(endData) {

      this.onWsCurrentGame(endData.currentGame);

      if (this.wheelState.game) {
        this.wheelState.game.status = GameStatus.ENDED;
        this.wheelState.game.winNumber = endData.Number || endData.number;
        this.wheelState.game.winColor = endData.ColorId || endData.colorId;

        this.$store.commit("setInfo");
      }

      console.warn("onWsGameEnded", endData);
    },

    // 收到新下注推送：实时更新区域底池、下注数组和玩家数统计
    onWsNewBet(data) {
      this.wheelState.game.totalBankUsd = data.totalBankUsd;
      this.wheelState.game.usersCount = data.usersCount;
      const betDto = data.bet;
      console.warn(betDto);
      betDto.isOwn = betDto.user.id == this.user.id;

      const targetColorKey = this.getColorKeyByMultiplier(betDto.color ?? betDto.colorId);
      if (targetColorKey && this.wheelState[targetColorKey]) {
        const colorBank = this.wheelState[targetColorKey];
        colorBank.totalBankUsd += (betDto.itemsTotal || betDto.betAmount || 0);

        const hasUserBet = colorBank.bets.some(b => b.user.id === betDto.userId);
        if (!hasUserBet) {
          colorBank.usersCount += 1;
        }

        colorBank.bets.unshift(betDto);
      }

      if (betDto.isOwn) {
        this.wheelState.userBets.unshift(betDto);
      }
    },

    getColorKeyByMultiplier(color) {
      if (color === Multiplier.X2 || color === 'X2' || color === 0) return 'colorX2';
      if (color === Multiplier.X3 || color === 'X3' || color === 1) return 'colorX3';
      if (color === Multiplier.X4 || color === 'X4' || color === 2) return 'colorX4';
      if (color === Multiplier.X35 || color === 'X35' || color === 3) return 'colorX35';
      return null;
    },

    handleBetSubmit(betData, doneCallback) {
      this.makeBet(betData.color, doneCallback);
    },

    handleNotifyError(msg) {
      if (this.$toast) {
        this.$toast.error(msg);
      } else if (this.$notify) {
        this.$notify({ type: 'error', message: msg });
      } else {
        alert(msg);
      }
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    toggleTurnOffAnimation() {
      this.turnOffAnimation = !this.turnOffAnimation;
    },
    formatHash(hash) {
      if (!hash || hash.length < 64) return hash;
      return `${hash.slice(0, 6)} ... ${hash.slice(58, 64)}`;
    },
    onColorClicked(color) {
      if (!this.authState.isAuthenticated()) {
        this.$emit('open-login-dialog');
        return;
      }

      const betAmount = this.getCurrentBetAmount();

      if (betAmount <= 0) return;

      if (betAmount < this.MIN_BET_AMOUNT_USD) {
        this.handleNotifyError('下注金额低于最低限制。最低下注金额：0.25 Coin');
        return;
      }

      if (this.isCreatingBet) return;

      if (this.betOnColorClick) {
        return this.makeBet(color);
      }

      this.openConfirmDialog(betAmount, color);
    },
    getCurrentBetAmount() {
      if (this.authState.betType() === 'BALANCE') {
        return this.authState.betAmountUsd;
      }
      return this.inventoryState.selectedInventoryAmountUsd();
    },
    openConfirmDialog(betAmount, color) {
      this.$emit('open-confirm-dialog', {
        betAmount,
        onConfirm: (neverAskAgain) => {
          if (neverAskAgain) {
            this.betOnColorClick = true;
            localStorage.setItem('wheelConfirm_betOnColorClick', JSON.stringify(true));
          }
          this.makeBet(color);
        }
      });
    },

    // 提交下注至后端
    async makeBet(color, doneCallback) {
      this.isCreatingBet = true;

      const request = {
        gameId: this.wheelState.game ? this.wheelState.game.id : 0,
        colorId: color,
        inventoryItems: this.authState.betType() === 'INVENTORY'
          ? this.inventoryState.selectedIds()
          : null,
        betAmount: this.authState.betType() === 'BALANCE'
          ? this.authState.betAmountUsd
          : null
      };

      const currencyType = Number(this.currencyType);

      try {
        await this.$wheelHub.conn.invoke('PlaceBet', request, currencyType);
      } catch (err) {
        console.error('下注服务端异常:', err);
        const fullMessage = err?.message || '下注失败';
        const match = fullMessage.match(/HubException:\s*(.*)/);
        const cleanErrorMessage = match ? match[1].trim() : fullMessage;
        this.handleNotifyError(cleanErrorMessage);
      } finally {
        this.isCreatingBet = false;
        this.$store.commit("setInfo");
        if (typeof doneCallback === 'function') {
          doneCallback();
        }
      }
    },
    async openHowGameWorksDialog(payload) {
      const slides = payload && payload.slides ? payload.slides : this.howItWorksSlides;
      this.$emit('open-how-it-works-dialog', { slides });
    },
    copyRoundHash(hash) {
      if (!hash) return;
      navigator.clipboard.writeText(hash).then(() => {
        if (this.$notify) {
          this.$notify({ type: 'success', message: '代码已复制' });
        } else {
          alert('代码已复制');
        }
      });
    },
    resetWheelState() {
      this.wheelState.game = new Game();
      this.wheelState.userBets = [];
      this.wheelState.colorX2 = new WheelColor();
      this.wheelState.colorX3 = new WheelColor();
      this.wheelState.colorX4 = new WheelColor();
      this.wheelState.colorX35 = new WheelColor();
    }
  }
};
